import { TuiSkeleton } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  RequestFormCommonAdditionalDataComponent,
  RequestFormCommonCarComponent,
  RequestFormCommonContractComponent,
  RequestFormCommonLesseeComponent,
  RequestFormCommonLogistsComponent,
  RequestFormCommonMainComponent,
  RequestFormCommonManagersComponent,
  RequestFormCommonSupplierComponent,
} from '@features/requests/request-form';
import { AsyncPipe, NgClass } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { IsLoadingService } from '@core/services';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'x-request-form-common',
  templateUrl: './request-form-common.component.html',
  imports: [
    TuiSkeleton,
    RequestFormCommonMainComponent,
    RequestFormCommonLesseeComponent,
    RequestFormCommonManagersComponent,
    RequestFormCommonAdditionalDataComponent,
    RequestFormCommonLogistsComponent,
    RequestFormCommonCarComponent,
    RequestFormCommonContractComponent,
    RequestFormCommonSupplierComponent,
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonComponent {
  private readonly formBuilder = inject(FormBuilder);
  readonly isLoading$: BehaviorSubject<boolean> = inject(IsLoadingService);
  /**
   * Локальный form-group нужен как provider FormGroupDirective для дочерних секций.
   * Эти секции инжектят FormGroupDirective и добавляют в него свои подгруппы.
   */
  readonly commonFormGroup = this.formBuilder.group({});
}
